import {Record, List} from 'immutable';
import {from} from 'rxjs';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import generateUUID from 'web-app/util/uuid';
import {type PushNotificationAppVariant} from 'web-app/services/push-notifications';
import {getApolloClient} from 'web-app/api/clients/famly-app';

import * as Queries from './queries';
import {type NotificationUpdatesQuery} from './__generated__/queries.api-types';

export const fetch = (offset: number = 0) =>
    RESTClient.getAuthenticatedObservable('v2/notifications', {
        uuid: generateUUID(),
        offset,
        limit: 10,
    }).map(response => List(response).map((data: any) => NotificationRecord(data)));

export const getNotificationCountsFromGraphQL = () =>
    from(
        getApolloClient().query<NotificationUpdatesQuery>({
            query: Queries.NotificationUpdates,
            fetchPolicy: 'network-only',
        }),
    );

export const markAllNotificationsAsSeen = () =>
    RESTClient.postAuthenticatedObservable('feed/feed/markallnotificationsasseen');

export const markNotificationAsRead = (notificationId: string) =>
    RESTClient.postAuthenticatedObservable(`v2/notifications/${notificationId}/read`);

export const updateDeviceToken = (
    deviceToken: string,
    appKind: string,
    pushAppId: string | undefined,
    variant: PushNotificationAppVariant,
) => {
    return RESTClient.postAuthenticatedObservable('v2/devicetokens', {
        deviceToken,
        type: appKind,
        pushAppId,
        variant,
    });
};

const NotificationRecord = Record({
    notificationId: null,
    body: null,
    createdDate: null,
    deletedAt: null,
    loginId: null,
    readDate: null,
    seenDate: null,
    sender: Record({
        name: null,
        profileImage: null,
        target: null,
    }),
    target: Record({
        type: null,
        feedItemId: null,
        childId: null,
        relationId: null,
        institutionId: null,
        employeeId: null,
        id: null,
    }),
});
